import styled from 'styled-components';
import { getBackgroundColor, themeGet } from '@magalu/stereo-ui-styles';
import Flex from '../Flex';
import Box from '../Box';
export const Container = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'background.lighter'
})`
  height: 24px;
`;
export const SliderField = styled(Box)`
  width: 100%;
`;
export const SliderTrack = styled(Box).attrs(props => Object.assign({}, props, {
  borderRadius: 'medium',
  zIndex: 0
}))`
  background-color: ${props => themeGet('baseColors.wildsand.base')(props)};
  position: absolute;
  height: 3px;
  width: 100%;
`;
export const SliderRange = styled(Box).attrs({
  bg: 'background.primary',
  borderRadius: 'medium',
  zIndex: 1
})`
  position: absolute;
  height: 3px;
`;
export const SliderInput = styled.input.attrs({
  type: 'range'
})`
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 100%;
  outline: none;
  z-index: ${props => props.overlapIndex ? themeGet(`zIndices.${props.overlapIndex}`)(props) : themeGet('zIndices.3')(props)};

  &,
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }

  &::-webkit-slider-thumb {
    background-color: ${getBackgroundColor('lighter')};
    border: ${props => themeGet('borders.0')(props)};
    border-radius: ${props => themeGet('radii.circle')(props)};
    box-shadow: ${props => themeGet('boxShadows.2')(props)};
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  &::-moz-range-thumb {
    background-color: ${getBackgroundColor('lighter')};
    border: ${props => themeGet('borders.0')(props)};
    border-radius: ${props => themeGet('radii.circle')(props)};
    box-shadow: ${props => themeGet('boxShadows.2')(props)};
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
`;